import React, { useEffect, useRef } from "react";
import isEqual from "lodash/isEqual";
import qs from "qs";
import { useLocation } from "react-router-dom";

const ScrollTop = Component => {
	function HOComponent(props) {
		const location = useLocation();
		const prevSearchRef = useRef();

		useEffect(() => {
			const el = document.querySelector(".devent-content");
			if (el) el.scrollTop = 0;
		}, []);

		useEffect(() => {
			if (prevSearchRef.current === undefined) {
				prevSearchRef.current = location.search;
				return;
			}
			const thisParams = qs.parse(location.search, {
				ignoreQueryPrefix: true
			});
			const prevParams = qs.parse(prevSearchRef.current, {
				ignoreQueryPrefix: true
			});
			if (!isEqual(thisParams, prevParams)) {
				const el = document.querySelector(".devent-content");
				if (el) el.scrollTop = 0;
			}
			prevSearchRef.current = location.search;
		}, [location.search]);

		return <Component {...props} />;
	}

	const wrappedName = Component.displayName || Component.name || "Component";
	HOComponent.displayName = `ScrollTop(${wrappedName})`;

	return HOComponent;
};

export default ScrollTop;
